import { APISettings } from '../../config/ApiSettings';
import { AdvanceFiling } from '../interfaces/AdvanceFiling';
import { BaseAPI } from './baseApi';

const baseUrl = new APISettings().getApiURL();

class FilingApi<Filing> extends BaseAPI {
  // constructor() {}

  public getFilings: () => Promise<Filing> = async () => {
    return (await BaseAPI.axios.get(`${baseUrl}/filing/GetByFilingFormId/6`)).data.output;
  };

  public getFilingsByFormId: (formId: number) => Promise<Filing> = async (formId: number) => {
    return (await BaseAPI.axios.get(`${baseUrl}/filing/GetByFilingFormId/${formId}`)).data.output;
  };

  public getFilingById: (filingId: number) => Promise<Filing> = async (filingId: number) => {
    return (await BaseAPI.axios.get(`${baseUrl}/filing/${filingId}`)).data.output;
  };

  public createFiling: (filing: Filing) => Promise<Filing> = async (filing: Filing) => {
    return (await BaseAPI.axios.post(`${baseUrl}/filing`, filing)).data.output;
  };

  public updateFiling: (filing: Filing) => Promise<Filing> = async (filing: Filing) => {
    return (await BaseAPI.axios.put(`${baseUrl}/filing`, filing)).data.output;
  };

  public getDashboardTableFilings: () => Promise<Filing> = async () => {
    return (await BaseAPI.axios.get(`${baseUrl}/filing/getDashboardTableFilings`)).data.output;
  }

  public advanceStatus: (advanceFilingDto: AdvanceFiling) => Promise<Filing> = async (advanceFilingDto: AdvanceFiling) => {
    return (await BaseAPI.axios.put(`${baseUrl}/filing/advance`, advanceFilingDto)).data.output;
  }

  public reject: (filingId: number, rejectReasonId: number) => Promise<boolean> = async (filingId: number, rejectReasonId: number) => {
    return (await BaseAPI.axios.put(`${baseUrl}/filing/${filingId}/reject/${rejectReasonId}`)).data.output;
  }

  public promulgate: (filingId: number) => Promise<boolean> = async (filingId: number) => {
    return (await BaseAPI.axios.post(`${baseUrl}/promulgation/${filingId}/promulgateTest`)).data.output;
  }

  public getHistorical: () => Promise<any> = async () => {
    return (await BaseAPI.axios.get(`${baseUrl}/filing/historical`)).data.output;
  }

  public deleteFiling: (id: number) => Promise<any> = async (id: number) => {
    return (await BaseAPI.axios.delete(`${baseUrl}/filing/${id}`)).data.output;
  }
}

export const filingAPI = new FilingApi();
